import { RoomattachfilesApi } from '../api-clients';
import { wrap } from '../wrap';

export const roomattachfileApi = {
  index: wrap(
    RoomattachfilesApi,
    RoomattachfilesApi.prototype.indexRoomAttachFile
  ),
  create: wrap(
    RoomattachfilesApi,
    RoomattachfilesApi.prototype.createRoomAttachFile
  ),
  delete: wrap(
    RoomattachfilesApi,
    RoomattachfilesApi.prototype.deleteRoomAttachFile
  ),
};
